import flatten from 'flat'
import dataTools from '../tools/data.js'

export default {
  computed: {
    // TODO clean the following lines
    axisOptions() {
      let options = []
      if (this.plotData != null && this.plotData.length > 0) {
        options = this.listAxisOptions(this.plotData)
      }
      return options
    },

    filteredAxisOptions() {
      let options = []
      if (this.filteredResults && this.filteredResults.length > 0) {
        options = this.listAxisOptions(this.filteredResults)
      } else if (this.plotData != null && this.plotData.length > 0) {
        options = this.listAxisOptions(this.plotData)
      }
      return options
    },

    treeOptions() {
      let options = []
      if (this.plotData != null && this.plotData.length > 0) {
        options = this.listTreeOptions(this.plotData)
      }
      return options
    },

    filteredTreeOptions() {
      let options = []
      if (this.filteredResults && this.filteredResults.length > 0) {
        options = this.listTreeOptions(this.filteredResults)
      } else if (this.plotData != null && this.plotData.length > 0) {
        options = this.listTreeOptions(this.plotData)
      }
      return options
    },

    isLineChart() {
      return this.configuration.type === 'Line/Scatter chart'
    },

    isMultiAxis() {
      return this.configuration.type === 'Multi axis'
    },

    isBarChart() {
      return this.configuration.type === 'Bar chart'
    },

    isDuration() {
      return this.configuration.x.path[0] === 'simulationDuration'
    },

    displayScatterShape() {
      return (
        (this.isLineChart || this.isMultiAxis) &&
        (this.configuration.scatterMode === 'lines+markers' ||
          this.configuration.scatterMode === 'lines')
      )
    },

    displayScatterText() {
      return (
        this.isLineChart && this.configuration.scatterMode === 'markers+text'
      )
    }
  },

  data: () => {
    return {
      dataTypeXIsString: false,
      dataTypeYIsString: false,
      multiAxisIndexesString: []
    }
  },

  methods: {
    addNewAxis() {
      this.configuration.multiAxis.push(this.buidDefaultPlotParameter())
    },

    removeLastAxis() {
      this.configuration.multiAxis.splice(-1, 1)
    },

    switchAxes() {
      ;[this.configuration.x, this.configuration.y] = [
        this.configuration.y,
        this.configuration.x
      ]
    },

    isChoice(options) {
      return options != null && options.length > 1
    },

    listAxisOptions(results) {
      return this.listAxisOptionsEvolvingOrConstants(
        results,
        this.configuration.displayNonEvolvingFields
      )
    },

    listAxisOptionsEvolvingOrConstants(results, displayNonEvolvingFields) {
      let allDataPaths = Object.keys(flatten(results[0])).map((key) =>
        key.split('.')
      )
      let variableData = allDataPaths
      if (!displayNonEvolvingFields) {
        variableData = dataTools.filterDataPathWithMultipleValues(
          allDataPaths,
          results
        )
      }
      // TODO use filter to remove options not usefull, e.g. combined ΔV
      return variableData.map((path) => ({
        value: path,
        text: dataTools.getDataLabel(path)
      }))
    },

    resetTreeConfig(config) {
      this.configuration.x = JSON.parse(JSON.stringify(config.x))
      this.configuration.y = JSON.parse(JSON.stringify(config.y))
      this.configuration.z = JSON.parse(JSON.stringify(config.z))
    },

    splitStringAtFirstUppercase(text) {
      const splitText = text.split(/(?=[A-Z])/)
      const firstElement = splitText.shift()
      const secondElement = splitText.join('')
      return [firstElement, secondElement]
    },

    listTreeOptions(
      results,
      type = this.type,
      fieldIndexes = this.fieldIndexes
    ) {
      let options = []
      let allDataPaths = Object.keys(flatten(results[0])).map((key) =>
        key.split('.')
      )
      if (this.configuration && !this.configuration.displayNonEvolvingFields) {
        allDataPaths = dataTools.filterDataPathWithMultipleValues(
          allDataPaths,
          results
        )
      }
      if (type === 'DeploymentResult') {
        allDataPaths = Object.keys(flatten(results[0])).map((key) =>
          key.replace(/\.[0-9]+\./g, '.')
        )
        allDataPaths = [...new Set(allDataPaths)].map((key) => key.split('.'))
      }
      // if simulation convert camelCase flat indexes to tree (cartesian(x,y,z) instead of cartesianX, ...)
      if (type === 'SimulationResult') {
        allDataPaths = Object.keys(fieldIndexes).map(
          this.splitStringAtFirstUppercase
        )
        allDataPaths = allDataPaths.map((el) => {
          // check if the field is single (simulationDuration or currentMass)
          let mainFieldCount = Object.keys(fieldIndexes).reduce((acc, curr) => {
            return acc + curr.startsWith(el[0])
          }, 0)
          if (mainFieldCount === 1) {
            return [el.join('')]
          }
          return el
        })
      }
      allDataPaths.forEach((parameterPath) => {
        let path = options
        let parameterLength = parameterPath.length
        let totalPath = []
        let totalID = ''
        while (parameterPath.length !== 0) {
          if (parameterPath.length === parameterLength) {
            totalID += parameterPath[0]
          } else {
            totalID += '.' + parameterPath[0]
          }
          totalPath.push(parameterPath[0])
          if (parameterPath.length === 1) {
            let fieldLabel = dataTools.getFieldLabelFromPath(
              type === 'SimulationResult' ? [totalPath.join('')] : totalPath,
              type
            )
            path.push({
              id: totalID,
              label:
                totalPath[0] === 'link'
                  ? dataTools.getDataLabel(totalPath)
                  : fieldLabel, // dataTools.formatToHuman(totalPath[totalPath.length - 1]),
              customLabel: dataTools.getDataLabel(totalPath)
            })
          } else {
            let fieldExists = path.find(
              (el) => el.label === dataTools.formatToHuman(parameterPath[0])
            )
            if (fieldExists) {
              path = fieldExists.children
            } else {
              path.push({
                id: totalID,
                label: dataTools.formatToHuman(parameterPath[0]),
                customLabel: dataTools.getDataLabel(totalPath),
                children: []
              })
              path = path[path.length - 1].children
            }
          }
          parameterPath = parameterPath.slice(1)
        }
      })
      options = this.sortTreeOptions(options, type)
      return options
    },

    sortTreeOptions(options, type = this.type) {
      // remove leaf with empty label
      options = options.filter((opt) => opt.children || opt.label !== '')

      options.forEach((opt) => {
        if (opt.children) {
          opt.children = this.sortTreeOptions(opt.children, type)
        }
      })
      return options.sort((a, b) => {
        if (type === 'SimulationResult') {
          let aPrio = dataTools.getFieldPriorityFromPath(
            [a.id.split('.').join('')],
            type
          )
          let bPrio = dataTools.getFieldPriorityFromPath(
            [b.id.split('.').join('')],
            type
          )
          if (aPrio - bPrio === 0) {
            return a.label < b.label ? -1 : 1
          }
          return aPrio - bPrio
        } else {
          if (a.id.startsWith('script') || b.id.startsWith('script')) {
            return 0
          }
          let aPrio = dataTools.getFieldPriorityFromPath(a.id.split('.'), type)
          let bPrio = dataTools.getFieldPriorityFromPath(b.id.split('.'), type)
          if (aPrio - bPrio === 0) {
            return a.label < b.label ? -1 : 1
          }
          return aPrio - bPrio
        }
      })
    },

    checkAndPushIndexStringMultiAxis(value) {
      for (let i = 0; i < this.multiAxisIndexesString.length; i++) {
        if (value === this.multiAxisIndexesString[i]) {
          return
        }
      }
      this.multiAxisIndexesString.push(value)
    },

    checkAndRemoveIndexStringMultiAxis(value) {
      let index = -1
      for (let i = 0; i < this.multiAxisIndexesString.length; i++) {
        if (value === this.multiAxisIndexesString[i]) {
          index = i
        }
      }
      if (index != -1) {
        return this.multiAxisIndexesString.splice(index, 1)
      } else {
        return this.multiAxisIndexesString
      }
    },

    treeUpdated(parameter, fieldName) {
      if (parameter.value) {
        if (this.type === 'SimulationResult') {
          parameter.path = [parameter.value.split('.').join('')]
        } else {
          parameter.path = parameter.value.split('.')
        }
        let dataType = ''
        if (parameter && parameter.path) {
          let scriptConfig =
            this.currentResultsLog != null
              ? this.currentResultsLog.scriptConfig
              : null
          dataType = dataTools.getFieldTypeFromPath(
            parameter.path,
            this.type,
            scriptConfig
          )
          if (dataType === 'string' && fieldName.split('')[0] === 'y') {
            if (this.isMultiAxis) {
              this.checkAndPushIndexStringMultiAxis(fieldName.substring(1))
            }
            this.dataTypeYIsString = true
          } else if (dataType === 'string' && fieldName === 'x') {
            this.dataTypeXIsString = true
          } else if (dataType !== 'string' && fieldName.split('')[0] === 'y') {
            if (this.isMultiAxis) {
              this.checkAndRemoveIndexStringMultiAxis(fieldName.substring(1))
              if (this.multiAxisIndexesString.length === 0) {
                this.dataTypeYIsString = false
              }
            } else {
              this.dataTypeYIsString = false
            }
          } else if (dataType !== 'string' && fieldName === 'x') {
            this.dataTypeXIsString = false
          }
        }
        parameter.unitOptions = dataTools.getAvailableUnits(dataType)
        // Without this if, the unit keeps getting updated for existing plots (resulting in the unit being reassigned to the one per default.)
        // Without the second check in unitOptions, the unit stays the same, even if we change the parameter in the plot config.
        if (
          parameter.unit === '' ||
          parameter.unitOptions.indexOf(parameter.unit) === -1
        ) {
          parameter.unit =
            dataTools.getDefaultGuiUnit(dataType) === 'DHMS'
              ? 'days'
              : dataTools.getDefaultGuiUnit(dataType)
        }
        parameter.label = dataTools.getDataLabel(parameter.path)
        if (parameter.path[0] === 'simulationDuration') {
          this.updateSliderData()
        }
      }
    },

    updateSliderData() {
      let sliderValues = []
      if (
        this.configuration.x &&
        this.configuration.x.path &&
        this.configuration.x.path[0] === 'simulationDuration' &&
        this.configuration.x.unit !== 'DHMS' &&
        this.configuration.x.unit !== '24h00'
      ) {
        sliderValues = this.getPlotValues(this.configuration.x, this.plotData)
      }
      if (sliderValues.length === 0) {
        this.configuration.durationSliderOptions = {
          label: 'Error reading parameters',
          min: 0,
          max: 0,
          step: 0
        }
      } else {
        this.configuration.durationSliderOptions = {
          label: 'Time Interval',
          min: Math.min(...sliderValues).toFixed(2),
          max: Math.max(...sliderValues).toFixed(2)
        }

        // TODO better step formula
        this.configuration.durationSliderOptions.step = (
          (this.configuration.durationSliderOptions.max -
            this.configuration.durationSliderOptions.min) /
          sliderValues.length
        ).toFixed(2)
      }
      this.configuration.durationSliderValue = [
        this.configuration.durationSliderOptions.min,
        this.configuration.durationSliderOptions.max
      ]
    },

    unitUpdated(parameter) {
      if (parameter.path[0] === 'simulationDuration') {
        this.updateSliderData()
      }
    },

    updatePlot(plotingArea, fromLayoutSave) {
      // TODO MFI check parameters ? invalid feedback to fill
      if (plotingArea) {
        this.$root.$emit(
          'create-plot',
          this.configuration,
          plotingArea,
          fromLayoutSave
        )
      }
    }
  }
}
